<template>
  <div>
    <v-card-title class="px-0">
      <v-icon size="18" class="pr-2 primary--text">mdi-ferry</v-icon>
      <b class="primary--text display"
        >{{ offerDemand.port.name.replace(".", "")
        }}<v-icon small class="px-1">mdi-arrow-right-bold</v-icon>{{ port }}</b
      >
      <v-spacer></v-spacer>
      <span right>
        <flag :iso="ports.find((p) => p.name == port).country.iso_code" />
        <span class="pl-2">{{
          ports.find((p) => p.name == port).country.name
        }}</span>
      </span>
    </v-card-title>
    <v-layout row align-center>
      <v-icon
        @click="show_customers = !show_customers"
        class="pr-1 primary--text"
        >{{ show_customers ? "arrow_drop_down" : "arrow_right" }}</v-icon
      >
      <div>
        <a
          @click="show_customers = !show_customers"
          style="vertical-align: text-bottom;"
          >{{
            companies.length +
            (companies.length > 1 ? " customers" : " customer") +
            " interested"
          }}:</a
        >
      </div>
    </v-layout>
    <v-slide-y-transition mode="out-in">
      <v-flex class="pl-4 pt-2" v-show="show_customers">
        <v-flex xs12 v-for="customer in companies" :key="customer.name">
          <v-icon size="12" class="pr-1 grey--text">store</v-icon>
          <a
            :href="'/companies/' + customer.id"
            target="_blank"
            class="caption grey--text"
            >{{ customer.name }}</a
          >
          <br />
        </v-flex>
      </v-flex>
    </v-slide-y-transition>
    <v-flex xs12 class="pt-4">
      <v-divider></v-divider>
    </v-flex>
    <!-- Global profit = {{ calculateProfit() }} -->
    <v-flex xs12 class="pt-3">
      <v-layout align-end justify-center row fill-height>
        <v-flex text-xs-center>
          <h3
            align-center
            row
            v-bind:style="{ color: netProfitColor(calculateProfit()) }"
          >
            {{ calculateProfit().toFixed(2) + " " + offerDemand.currency.name }}
          </h3>
          <h4>{{ caluclateProfitPercentage().toFixed(2) }} %</h4>
          <p align-center class="font-weight-medium font-italic">
            TOTAL PROFIT
          </p>
        </v-flex>
      </v-layout>
      <v-divider style="padding-bottom: 8px;"></v-divider>
    </v-flex>

    <!-- Incoterm -->

    <v-stepper :value="selectedStep" vertical>
      <!-- Other Costs -->
      <v-stepper-step
        editable
        :complete="true"
        edit-icon="assignment"
        :step="0"
        @click="stepperClick(0)"
      >
        Incoterm
        <small v-if="incotermId">{{
          incoterms.find((ic) => ic.id == incotermId).name
        }}</small>
        <small v-else>Select an Incoterm</small>
      </v-stepper-step>

      <v-stepper-content :step="0">
        <v-autocomplete
          class="fixedPadding"
          :items="incoterms"
          prepend-inner-icon="assignment"
          item-value="id"
          item-text="name"
          background-color="white"
          label="Incoterm"
          v-model="incotermId"
          box
          browser-autocomplete="noautocomplete"
        ></v-autocomplete>
      </v-stepper-content>

      <!-- Shipping Marker Supplier Type -->
      <template
        v-for="(supplier_type, i) in supplier_types.filter(
          (e) => e.is_shipping_market
        )"
      >
        <v-stepper-step
          editable
          non-linear
          edit-icon="store"
          :key="supplier_type.name"
          :complete="true"
          :step="i + 2"
          @click="stepperClick(i + 2)"
        >
          <span>
            <v-tooltip top>
              <v-icon
                size="14"
                slot="activator"
                color="#888"
                style="position: relative; top: -1px;"
                dark
                >help</v-icon
              >
              <span>{{
                getStepHelpText("freight_rate", supplier_type.name)
              }}</span>
            </v-tooltip>
            {{ supplier_type.name }}
          </span>
          <small>
            <span
              v-if="
                fetchShippingMarket(supplier_type.id).filter(
                  (sm) => sm.id == shippingMarketCompanies[supplier_type.id]
                )[0] && shippingMarketCompanies[supplier_type.id]
              "
              >{{
                fetchShippingMarket(supplier_type.id).filter(
                  (sm) => sm.id == shippingMarketCompanies[supplier_type.id]
                )[0].company.name
              }}
              -</span
            >
            <strong
              >Total {{ supplier_type.name.replace(".", " ") }} costs for
              {{ offerDemand.shipping_quantity }}
              {{ pluralShipmentName() }}:</strong
            >
            <span class="error--text caption pl-2">{{
              totalShippingPrice(supplier_type.id).toFixed(2) +
              " " +
              globalCurrencyName
            }}</span>
          </small>
        </v-stepper-step>

        <v-stepper-content :key="i" :step="i + 2">
          <template v-if="fetchShippingMarket(supplier_type.id).length == 0">
            <v-autocomplete
              class="fixedPadding error-text"
              disabled
              error
              prepend-inner-icon="warning"
              background-color="white"
              :label="supplier_type.name.replace('.', ' ') + ' company'"
              box
              browser-autocomplete="noautocomplete"
            ></v-autocomplete>
            <v-flex text-xs-center pt0>
              <span class="caption">
                <v-icon small class="pr-2" color="error">warning</v-icon>No
                <b>{{ supplier_type.name.replace(".", " ") }} Rate Company</b>
                match desired origin port and/or destination port.
              </span>
              <template v-if="currentUserCan('see', 'freight_rates')">
                <br />
                <span class="caption">
                  You can go to the
                  <v-icon color="primary" small>open_in_new</v-icon>
                  <a target="_blank" href="/shipping_market">Freight Rates</a>
                  page to create a new
                  <b>Freight Rate.</b>
                </span>
              </template>
              <br />
            </v-flex>
          </template>
          <template v-else>
            <v-autocomplete
              class="fixedPadding"
              :items="fetchShippingMarket(supplier_type.id)"
              prepend-inner-icon="store"
              item-value="id"
              item-text="company.name"
              background-color="white"
              :label="supplier_type.name.replace('.', ' ') + ' company'"
              v-model="shippingMarketCompanies[supplier_type.id]"
              @change="setPrice(supplier_type.id, $event)"
              box
              browser-autocomplete="noautocomplete"
            >
              <template v-slot:item="data">
                <template
                  v-if="Date.parse(data.item.expiration_date) < Date.now()"
                >
                  <v-list-tile-content
                    class="red--text"
                    v-text="
                      constructDataItemName(data.item) +
                      ' (Expired ' +
                      supplier_type.name.replace('.', ' ') +
                      ' Rate)'
                    "
                  ></v-list-tile-content>
                </template>
                <template
                  v-if="Date.parse(data.item.expiration_date) >= Date.now()"
                >
                  <v-list-tile-content
                    v-text="constructDataItemName(data.item)"
                  ></v-list-tile-content>
                </template>
              </template>
            </v-autocomplete>
          </template>
          <v-text-field
            autocomplete="nothingplease"
            :label="
              supplier_type.name.replace('.', ' ') +
              ' cost per ' +
              offerDemand.shipment.name
            "
            type="number"
            v-model="shippingMarketCosts[supplier_type.id]"
            prepend-inner-icon="attach_money"
          />
          <v-container grid fluid pa-0>
            <v-layout row justify-begin>
              <v-flex px-1 xs8>
                <v-autocomplete
                  class="fixedPadding"
                  :items="currencies"
                  prepend-inner-icon="attach_money"
                  item-value="name"
                  item-text="name"
                  background-color="white"
                  :label="supplier_type.name.replace('.', ' ') + 'Currency'"
                  v-model="shippingMarketCurrencyNames[supplier_type.id]"
                  @change="setChangeRate(supplier_type.id, $event)"
                  box
                  browser-autocomplete="noautocomplete"
                ></v-autocomplete>
              </v-flex>
              <v-flex px-1 xs4>
                <v-text-field
                  prepend-icon="compare_arrows"
                  :value="globalCurrencyName"
                  :disabled="true"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
          <v-slide-y-transition mode="out-in">
            <v-text-field
              v-show="
                shippingMarketCurrencyNames[supplier_type.id] &&
                globalCurrencyName &&
                shippingMarketCurrencyNames[supplier_type.id] !=
                  globalCurrencyName
              "
              autocomplete="nothingplease"
              :label="
                shippingMarketCurrencyNames[supplier_type.id] +
                ' => ' +
                globalCurrencyName +
                ' exchange rate'
              "
              type="number"
              v-model="shippingMarketChangeRates[supplier_type.id]"
              prepend-inner-icon="compare_arrows"
              value="1"
            />
          </v-slide-y-transition>
        </v-stepper-content>
      </template>

      <!-- Other Costs -->
      <v-stepper-step
        editable
        :complete="true"
        edit-icon="payment"
        :step="supplier_types.filter((e) => e.is_shipping_market).length + 2"
        @click="
          stepperClick(
            supplier_types.filter((e) => e.is_shipping_market).length + 2
          )
        "
      >
        Other Costs
        <small>
          Insurance, DHL ...
          <span v-if="otherCosts">
            -
            <strong
              >Total other costs for {{ offerDemand.shipping_quantity }}
              {{ pluralShipmentName() }}:</strong
            >
            <span class="error--text caption pl-2">{{
              (
                otherCosts *
                (otherCostsChangeRate || 1) *
                offerDemand.shipping_quantity
              ).toFixed(2) +
              " " +
              globalCurrencyName
            }}</span>
          </span>
        </small>
      </v-stepper-step>

      <v-stepper-content
        :step="supplier_types.filter((e) => e.is_shipping_market).length + 2"
      >
        <v-text-field
          autocomplete="nothingplease"
          :label="'Other costs per ' + offerDemand.shipment.name"
          v-model="otherCosts"
          prepend-inner-icon="payment"
        />
        <v-container grid fluid pa-0>
          <v-layout row justify-begin>
            <v-flex px-1 xs8>
              <v-autocomplete
                class="fixedPadding"
                :items="currencies"
                prepend-inner-icon="attach_money"
                item-value="name"
                item-text="name"
                background-color="white"
                label="Other costs currency"
                v-model="otherCostsCurrencyName"
                @change="setOtherCostChangeRate($event)"
                box
                browser-autocomplete="noautocomplete"
              ></v-autocomplete>
            </v-flex>
            <v-flex px-1 xs4>
              <v-text-field
                prepend-icon="compare_arrows"
                :value="globalCurrencyName"
                :disabled="true"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>

        <v-slide-y-transition mode="out-in">
          <v-text-field
            v-show="
              otherCostsCurrencyName &&
              globalCurrencyName &&
              otherCostsCurrencyName != globalCurrencyName
            "
            autocomplete="nothingplease"
            :label="
              otherCostsCurrencyName +
              ' => ' +
              globalCurrencyName +
              ' exchange rate'
            "
            type="number"
            v-model="otherCostsChangeRate"
            prepend-inner-icon="compare_arrows"
            value="1"
          />
        </v-slide-y-transition>
      </v-stepper-content>

      <!-- Products Profit  -->
      <template v-for="(ppe, i) in offerDemand.product_packagings_entities">
        <v-stepper-step
          @click="
            stepperClick(
              supplier_types.filter((e) => e.is_shipping_market).length + 3 + i
            )
          "
          edit-icon="shopping_cart"
          editable
          :key="ppe.product.name"
          :complete="true"
          :step="
            supplier_types.filter((e) => e.is_shipping_market).length + 3 + i
          "
        >
          <span>
            {{ truncateBreakpoint(ppe.product.name) }}
            <span class="pl-2">({{ ppe.weight_mt }} mt)</span>
          </span>

          <small>
            Buying Price: {{ ppe.price }} -
            <strong>Selling Price: </strong>
            <span class="pl-2 success--text caption"
              >{{
                calculatePrice(ppe).toFixed(2) +
                " " +
                offerDemand.currency.name.replace(".", "") +
                " / mt"
              }}
            </span>
            <br />
            <b>Total Charges: </b>
            <span class="pl-2 error--text caption"
              >{{
                calculateCharges().toFixed(2) +
                " - " +
                offerDemand.currency.name.replace(".", "") +
                " / mt"
              }}
            </span>
          </small>
        </v-stepper-step>

        <v-stepper-content
          :key="ppe.product.id"
          :step="
            supplier_types.filter((e) => e.is_shipping_market).length + 3 + i
          "
        >
          <v-text-field
            autocomplete="nothingplease"
            v-model="profitPerMt[ppe.product_id]"
            :suffix="
              '(' +
              (
                ((profitPerMt[ppe.product_id] || 0) / calculatePrice(ppe)) *
                100
              ).toFixed(2) +
              '% margin)'
            "
            prepend-inner-icon="shopping_cart"
          >
            <template v-slot:label>
              Margin in
              <strong>{{ offerDemand.currency.name.replace(".", "") }}</strong>
              per mt
            </template>
          </v-text-field>
        </v-stepper-content>
      </template>

      <!-- Salesforces Synchronisation -->
      <v-stepper-step
        @click="
          stepperClick(
            supplier_types.filter((e) => e.is_shipping_market).length +
              offerDemand.product_packagings_entities.length +
              3
          )
        "
        editable
        :complete="true"
        edit-icon="mdi-salesforce"
        :step="
          supplier_types.filter((e) => e.is_shipping_market).length +
          offerDemand.product_packagings_entities.length +
          3
        "
      >
        Salesforces
        <small>Synchronize this offer with Salesforce Platform</small>
      </v-stepper-step>

      <v-stepper-content
        :step="
          supplier_types.filter((e) => e.is_shipping_market).length +
          offerDemand.product_packagings_entities.length +
          3
        "
      >
        <v-btn
          :disabled="disabledButton"
          color="#00a2e1"
          block
          depressed
          dark
          @click="sendToSalesforce()"
        >
          <v-icon class="pr-2" small>mdi-salesforce</v-icon>
          <span class="body-2">Sync with salesforce</span>
        </v-btn>
      </v-stepper-content>
    </v-stepper>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import SALESFORCE_SYNC_OFFER from "../../graphql/offers/salesforce_sync.gql";
import axios from "axios";
import pluralize from "pluralize";

export default {
  data() {
    return {
      incotermId: "",
      shippingMarketCompanies: {},
      shippingMarketCosts: {},
      shippingMarketIds: {},
      shippingMarketCurrencyNames: {},
      shippingMarketChangeRates: {},
      otherCosts: 200,
      otherCostsCurrencyName: "",
      otherCostsChangeRate: 1,
      profitPerMt: {},
      disabledButton: false,
      show_customers: false,
      globalCurrencyName: undefined,
      selectedStep: -1,
    };
  },
  props: {
    port: {
      type: String,
      required: true,
    },
    companies: {
      type: Array,
      required: true,
    },
    offerDemand: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters("commonStore", [
      "serviceSuppliers",
      "supplier_types",
      "shipping_markets",
      "ports",
      "currencies",
      "incoterms",
    ]),
    ...mapGetters("companyStore", ["offers"]),
  },
  mounted() {
    this.globalCurrencyName = this.offerDemand.currency.name;
    this.otherCostsCurrencyName = this.offerDemand.currency.name;
  },
  methods: {
    truncateBreakpoint(input) {
      if (this.$vuetify.breakpoint.xs && input.length > 20)
        return input.substring(0, 20) + "...";

      if (this.$vuetify.breakpoint.sm && input.length > 30)
        return input.substring(0, 30) + "...";

      if (input.length > 50) return input.substring(0, 50) + "...";

      return input;
    },
    getStepHelpText(type, variable) {
      switch (type) {
        case "freight_rate":
          return (
            "Select one of the " +
            variable.replace(".", "") +
            " rate available from this port of loading to this Port of destination"
          );
          break;
      }
    },
    pluralShipmentName() {
      return pluralize(
        this.offerDemand.shipment.name.replace(".", ""),
        this.offerDemand.shipping_quantity
      );
    },
    totalShippingPrice(st_id) {
      let total = 0;
      if (this.shippingMarketCurrencyNames[st_id] != this.globalCurrencyName)
        total =
          this.shippingMarketCosts[st_id] *
          ((this.shippingMarketChangeRates &&
            this.shippingMarketChangeRates[st_id]) ||
            1) *
          this.offerDemand.shipping_quantity;
      else
        total =
          (this.shippingMarketCosts[st_id] || 0) *
          this.offerDemand.shipping_quantity;

      return total || 0;
    },
    calculatePrice(ppe) {
      return (
        (parseFloat(this.profitPerMt[ppe.product_id]) || 0) +
        ppe.price +
        this.calculateCharges()
      );
    },
    stepperClick(step) {
      // Used to 'close' the stepper, can't close stepper using a regular v-model
      if (this.selectedStep == step) this.selectedStep = -1;
      else this.selectedStep = step;
    },
    setOtherCostsCurrency() {
      if (this.otherCostsCurrencyName.length < 1)
        this.otherCostsCurrencyName = this.globalCurrencyName;
    },
    netProfitColor(netprofit) {
      return netprofit > 0 ? `#50a55c` : `#da4545`;
    },
    setPrice(supplierTypeId, shippingMarketId) {
      this.$set(
        this.shippingMarketCosts,
        supplierTypeId,
        this.shipping_markets.filter((s) => s.id == shippingMarketId)[0].price
      );

      this.$set(this.shippingMarketIds, supplierTypeId, shippingMarketId);

      this.$set(
        this.shippingMarketCurrencyNames,
        supplierTypeId,
        this.shipping_markets.filter((s) => s.id == shippingMarketId)[0]
          .currency.name
      );
      const currentCurrencyCode = this.currencies.filter(
        (c) => c.name == this.shippingMarketCurrencyNames[supplierTypeId]
      )[0].code;
      const globalCurrencyCode = this.currencies.filter(
        (c) => c.name == this.globalCurrencyName
      )[0].code;
      axios
        .get(
          `https://api.exchangeratesapi.io/latest?base=${currentCurrencyCode}&access_key=33e4c95e949530932ce095bf30cfddd3`
        )
        .then((data) => {
          this.$set(
            this.shippingMarketChangeRates,
            supplierTypeId,
            data.data.rates[globalCurrencyCode]
          );
        })
        .catch(() => {
          this.$set(this.shippingMarketChangeRates, supplierTypeId, 1);
        });
    },
    setChangeRate(supplierTypeId, newCurrency) {
      const currentCurrencyCode = this.currencies.filter(
        (c) => c.name == newCurrency
      )[0].code;
      const globalCurrencyCode = this.currencies.filter(
        (c) => c.name == this.globalCurrencyName
      )[0].code;
      axios
        .get(
          `https://api.exchangeratesapi.io/latest?base=${currentCurrencyCode}&access_key=33e4c95e949530932ce095bf30cfddd3`
        )
        .then((data) => {
          this.$set(
            this.shippingMarketChangeRates,
            supplierTypeId,
            data.data.rates[globalCurrencyCode]
          );
        })
        .catch(() => {
          this.$set(this.shippingMarketChangeRates, supplierTypeId, 1);
        });
    },
    setOtherCostChangeRate(newCurrency) {
      const currentCurrencyCode = this.currencies.filter(
        (c) => c.name == newCurrency
      )[0].code;
      const globalCurrencyCode = this.currencies.filter(
        (c) => c.name == this.globalCurrencyName
      )[0].code;

      axios
        .get(
          `https://api.exchangeratesapi.io/latest?base=${currentCurrencyCode}&access_key=33e4c95e949530932ce095bf30cfddd3`
        )
        .then((data) => {
          this.otherCostsChangeRate = data.data.rates[globalCurrencyCode];
        })
        .catch(() => {
          this.otherCostsChangeRate = 1;
        });
    },
    fetchShippingMarket(supplierTypeId) {
      return this.shipping_markets
        .filter((s) => s.supplier_type_id == supplierTypeId)
        .filter((s) =>
          s.product_category_ids.includes(
            this.offerDemand.product_packagings_entities[0].product
              .product_category_id
          )
        )
        .filter((s) => s.shipment_id == this.offerDemand.shipment_id)
        .filter((s) => {
          return (
            s.port_of_destinations.map((p) => p.name).includes(this.port) &&
            s.port_of_origins
              .map((p) => p.name)
              .includes(this.offerDemand.port.name)
          );
        });
    },
    caluclateProfitPercentage() {
      let total = 0;
      this.offerDemand.product_packagings_entities.forEach((ppe) => {
        total += this.calculatePrice(ppe) * ppe.weight_mt;
      });

      return (this.calculateProfit() / total) * 100;
    },
    calculateProfit() {
      let total = 0;

      this.offerDemand.product_packagings_entities.forEach((ppe) => {
        total +=
          ppe.weight_mt * parseFloat(this.profitPerMt[ppe.product_id] || 0);
      });

      return total;
    },
    constructDataItemName(item) {
      const l = this.companies.filter((c) =>
        c.customer.company_ids.includes(item.shipping_line_id)
      ).length;

      let text = item.company.name;

      if (l > 0) text = text + ` (${l} customer(s) unhappy with shipping line)`;

      if (item.shipping_line && item.shipping_line.name)
        text += ` (${item.shipping_line.name})`;

      return text;
    },
    calculateCharges() {
      let total = 0;
      this.supplier_types
        .filter((e) => e.is_shipping_market)
        .forEach((st) => {
          if (this.shippingMarketCosts && this.shippingMarketCosts[st.id]) {
            if (
              this.shippingMarketCurrencyNames[st.id] != this.globalCurrencyName
            )
              total +=
                this.shippingMarketCosts[st.id] *
                ((this.shippingMarketChangeRates &&
                  this.shippingMarketChangeRates[st.id]) ||
                  1) *
                this.offerDemand.shipping_quantity;
            else
              total +=
                this.shippingMarketCosts[st.id] *
                this.offerDemand.shipping_quantity;
          }
        });

      if (this.otherCostsChangeRate)
        total +=
          this.otherCosts *
          this.otherCostsChangeRate *
          this.offerDemand.shipping_quantity;
      else total += this.otherCosts * this.offerDemand.shipping_quantity;

      return (
        total /
        this.offerDemand.product_packagings_entities
          .map((ppe) => ppe.weight_mt)
          .reduce((v, a) => a + v, 0)
      );
    },
    sendToSalesforce() {
      let obj = {};
      this.disabledButton = true;

      if (this.incotermId) obj.incoterm_id = this.incotermId;
      obj.port = this.port;
      obj.id = this.offerDemand.id;
      obj.customer_company_ids = this.companies.map((e) => e.id);
      console.log(this.supplier_types.filter((e) => e.is_shipping_market));
      let freightCost = 0;
      let waiverCost = 0;
      let freightShippingMarketId = "";
      let waiverShippingMarketId = "";

      this.supplier_types
        .filter((e) => e.is_shipping_market)
        .forEach((st) => {
          console.log(this.shippingMarketCosts[st.id]);
          if (st.name == "Freight.") {
            if (this.shippingMarketCosts && this.shippingMarketCosts[st.id])
              if (
                this.shippingMarketCurrencyNames[st.id] !=
                this.globalCurrencyName
              )
                freightCost =
                  this.shippingMarketCosts[st.id] *
                  ((this.shippingMarketChangeRates &&
                    this.shippingMarketChangeRates[st.id]) ||
                    1);
              else freightCost = this.shippingMarketCosts[st.id];
            if (this.shippingMarketIds && this.shippingMarketIds[st.id])
              freightShippingMarketId = this.shippingMarketIds[st.id];
          }

          if (st.name == "Waiver.") {
            if (this.shippingMarketCosts && this.shippingMarketCosts[st.id])
              if (
                this.shippingMarketCurrencyNames[st.id] !=
                this.globalCurrencyName
              )
                waiverCost =
                  this.shippingMarketCosts[st.id] *
                  ((this.shippingMarketChangeRates &&
                    this.shippingMarketChangeRates[st.id]) ||
                    1);
              else waiverCost = this.shippingMarketCosts[st.id];
            if (this.shippingMarketIds && this.shippingMarketIds[st.id])
              waiverShippingMarketId = this.shippingMarketIds[st.id];
          }
        });
      obj.freight_shipping_market_id = freightShippingMarketId;
      obj.waiver_shipping_market_id = waiverShippingMarketId;
      obj.shipment_freight_fees = parseFloat(freightCost);
      obj.shipment_waiver_fees = parseFloat(waiverCost);
      obj.shipment_other_costs = this.otherCosts * this.otherCostsChangeRate;

      obj.product_margins = this.offerDemand.product_packagings_entities.map(
        (ppe) => {
          return {
            product_id: ppe.product_id,
            buying_price: ppe.price,
            selling_price: parseFloat(this.calculatePrice(ppe).toFixed(2)),
            total_charges: parseFloat(this.calculateCharges().toFixed(2)),
          };
        }
      );

      this.sendMutation("synced", "salesforce", SALESFORCE_SYNC_OFFER, obj)
        .then(() => {})
        .catch(() => {
          this.disabledButton = false;
        });
    },
  },
};
</script>
